import { ContentId, ContentType, DocumentId } from './contentMetadata';

export type ExperimentId = string;

export type VariantId = string;

export enum ExperimentState {
  NotStarted = 'NotStarted',
  Started = 'Started',
  Stopped = 'Stopped',
  Ended = 'Ended',
}

export enum VariantType {
  ContentVariant = 'ContentVariant',
  ControlVariant = 'ControlVariant',
}

export interface Experiment {
  id: ExperimentId;
  name: string;
  allocationSeed: string;
  variants: ExperimentVariant[];
  state: ExperimentState;
  segmentIds?: string[];
  controlVariantRequired: boolean;
  weightings?: Record<string, number>;
  allocationUnit: string;
  createdAt: string;
  startedAt?: string;
  lastModifiedAt: string;
  completedAt?: string;
  createdBy: number;
  progressiveRollout?: number;
  excludeContentIds?: [];
  excludeExperimentIds?: [];
}

export interface ExperimentVariant {
  id: VariantId;
  experimentId: ExperimentId;
  name: string;
  contentId: ContentId;
  documentId: DocumentId;
  sortOrder: number;
  type: VariantType;
}

export type CreateExperimentVariant = {
  experimentId: ExperimentId;
  name: string;
  sortOrder: number;
  contentType: ContentType;
  type: VariantType;
};
